import React from 'react';
import PropTypes from 'prop-types';
import './Watermark.css';

const Watermark = ({ 
  text = 'CONFIDENTIAL', 
  opacity = 0.20, 
  angle = 0,
  fontSize = '14px',
  color = '#000000',
  spacing = 200 
}) => {
  return (
    <div 
      style={{
        position: 'fixed',
        top: '90px',
        right: '100px',
        pointerEvents: 'none',
        zIndex: 9999,
        transformOrigin: 'top right',
        textAlign: 'right'
      }}
    >
      <div 
        className="app-environment-watermark"
        style={{
          transform: `rotate(${angle}deg)`,
          fontSize: fontSize,
          color: color,
          opacity: opacity,
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          userSelect: 'none',
          whiteSpace: 'nowrap',
          letterSpacing: '2px'
        }}
      >
        {text}
      </div>
    </div>
  );
};

Watermark.propTypes = {
  text: PropTypes.string,
  opacity: PropTypes.number,
  angle: PropTypes.number,
  fontSize: PropTypes.string,
  color: PropTypes.string,
  spacing: PropTypes.number
};

export default Watermark;
